import React from 'react';
import { Loader } from '../../../common/components/Loader';

/**
 * Rendered by App.tsx while authStatus === 'initializing' to prevent
 * premature navigation to /login before the async session check completes.
 */
export const AuthInitPlaceholder: React.FC = () => (
  <div
    data-testid="auth-init-placeholder"
    className="flex h-screen w-full items-center justify-center bg-canvas"
  >
    <Loader data-testid="auth-init-loader" />
  </div>
);
